var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {}, [_vm.initLoading ? _c('ComponentLoader', {
    attrs: {
      "loading": _vm.initLoading
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "search_filter",
    attrs: {
      "id": "__rm_search_filter"
    }
  }, [_c('div', {
    staticClass: "search-input"
  }), !_vm.initLoading ? _c('el-button', {
    attrs: {
      "type": "success contacts_lg_btn last_btn contact_btn_green"
    },
    on: {
      "click": function ($event) {
        return _vm.addNewGroup('import');
      }
    }
  }, [_c('img', {
    attrs: {
      "height": "17",
      "src": "data:image/svg+xml;base64,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"
    }
  }), _vm._v("   " + _vm._s(_vm.$t("dashboard.contacts.excel.import")) + " ")]) : _vm._e()], 1), !_vm.initLoading ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "groups mnotify-card __main__group",
    staticStyle: {
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "mnotify-card-header d-flex justify-content-between align-items-center"
  }, [_c('h3', {
    staticClass: "mnotify-card-header-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("dashboard.groups.groups")) + " " + _vm._s(`(${_vm.total})`) + " ")]), _vm.total > 0 ? _c('button', {
    staticClass: "__add__group_contact__btn add-contact-button-icon",
    on: {
      "click": function ($event) {
        return _vm.addNewGroup('new');
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "17",
      "viewBox": "0 0 16 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4.536 0.0664062H11.472C14.184 0.0664062 16 1.97041 16 4.80241V11.3392C16 14.1632 14.184 16.0664 11.472 16.0664H4.536C1.824 16.0664 0 14.1632 0 11.3392V4.80241C0 1.97041 1.824 0.0664062 4.536 0.0664062ZM4.58669 8.0587C4.58612 8.4428 4.89725 8.75392 5.28192 8.75392L7.29576 8.75392L7.29632 10.7683C7.29576 11.1524 7.61254 11.4692 7.99721 11.4692C8.38244 11.4698 8.69357 11.1587 8.69866 10.7678L8.69357 8.76015L10.7068 8.75958C11.0977 8.75449 11.4089 8.44336 11.4083 8.05813C11.4083 7.67346 11.0915 7.35668 10.7074 7.35725L8.693 7.35668L8.69866 5.3485C8.693 4.95818 8.38187 4.64705 7.99777 4.64761C7.80544 4.64761 7.62385 4.72624 7.4994 4.8507C7.3693 4.9808 7.29632 5.15673 7.29632 5.34906L7.2901 7.35668L5.28248 7.3629C5.08393 7.35668 4.91422 7.43588 4.78977 7.56033C4.65966 7.69044 4.58669 7.86636 4.58669 8.0587Z",
      "fill": "#D4D8E2"
    }
  })]), _vm._v("  " + _vm._s(_vm.$t("dashboard.groups.create_new")) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "card-inner"
  }, [_vm.total == 0 ? _c('div', {
    staticClass: "groups_no_data_state"
  }, [_c('h3', {
    staticClass: "empty_header"
  }, [_vm._v(" " + _vm._s(_vm.$t("dashboard.groups.no_group")) + " ")]), _c('p', {
    staticClass: "empty_text_sm"
  }, [_vm._v(" " + _vm._s(_vm.$t("dashboard.groups.create_new")) + " ")]), _c('el-button', {
    staticStyle: {
      "width": "auto",
      "border-radius": "5px",
      "font-weight": "600",
      "height": "43px",
      "font-size": "14px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.addNewGroup('new');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("dashboard.groups.create_new")) + " ")])], 1) : _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.isTableLoading,
      expression: "isTableLoading"
    }],
    attrs: {
      "data": _vm.groups,
      "height": "60vh"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('dashboard.contacts.excel.group_name')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          staticClass: "notranslate"
        }, [_vm._v(_vm._s(scope.row.name))])];
      }
    }], null, false, 1747746112)
  }), _c('el-table-column', {
    attrs: {
      "prop": "contact_count",
      "label": _vm.$t('dashboard.groups.member_count')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.contact_count) + " " + _vm._s(_vm.$t("dashboard.groups.members")) + " ")];
      }
    }], null, false, 946701942)
  }), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('misc.table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "group__action"
        }, [_c('button', {
          staticClass: "__group__action_btn contacts-button",
          attrs: {
            "title": "View Contacts In Group"
          },
          on: {
            "click": function ($event) {
              return _vm.viewContacts(scope.row);
            }
          }
        }, [_c('svg', {
          attrs: {
            "id": "SvgjsSvg1001",
            "width": "22",
            "height": "22",
            "xmlns": "http://www.w3.org/2000/svg",
            "version": "1.1",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:svgjs": "http://svgjs.com/svgjs"
          }
        }, [_c('defs', {
          attrs: {
            "id": "SvgjsDefs1002"
          }
        }), _c('g', {
          attrs: {
            "id": "SvgjsG1008",
            "transform": "matrix(1,0,0,1,0,0)"
          }
        }, [_c('svg', {
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "22",
            "height": "22",
            "fill": "none",
            "viewBox": "0 0 23 18"
          }
        }, [_c('path', {
          staticClass: "color000 svgShape colorStroke200E32 svgStroke",
          attrs: {
            "stroke": "#d4d8e2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            "d": "M17.5948 7.93189C19.1972 7.93189 20.497 6.63298 20.497 5.03064 20.497 3.42831 19.1972 2.12939 17.5948 2.12939M18.9291 11.0847C19.4076 11.1177 19.8833 11.1856 20.3517 11.291 21.0026 11.4184 21.7854 11.6851 22.0641 12.2691 22.2419 12.6431 22.2419 13.0785 22.0641 13.4534 21.7863 14.0373 21.0026 14.3031 20.3517 14.437M6.28998 7.93189C4.68765 7.93189 3.38782 6.63298 3.38782 5.03064 3.38782 3.42831 4.68765 2.12939 6.28998 2.12939M4.95577 11.0847C4.47727 11.1177 4.00152 11.1856 3.5331 11.291 2.88227 11.4184 2.09943 11.6851 1.82168 12.2691 1.64293 12.6431 1.64293 13.0785 1.82168 13.4534 2.09852 14.0373 2.88227 14.3031 3.5331 14.437",
            "fill": "#d4d8e2"
          }
        }), _c('path', {
          staticClass: "color000 svgShape colorStroke200E32 svgStroke",
          attrs: {
            "stroke": "#d4d8e2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            "d": "M11.9377 11.7095C15.1846 11.7095 17.9584 12.2008 17.9584 14.1671 17.9584 16.1324 15.2029 16.6421 11.9377 16.6421 8.68997 16.6421 5.91705 16.1507 5.91705 14.1845 5.91705 12.2182 8.67255 11.7095 11.9377 11.7095zM11.9377 8.90492C9.79638 8.90492 8.07947 7.188 8.07947 5.04575 8.07947 2.90442 9.79638 1.1875 11.9377 1.1875 14.0791 1.1875 15.796 2.90442 15.796 5.04575 15.796 7.188 14.0791 8.90492 11.9377 8.90492z",
            "clip-rule": "evenodd",
            "fill": "#d4d8e2"
          }
        })])])])]), _c('button', {
          staticClass: "__group__action_btn edit-group",
          attrs: {
            "title": "Edit Group Name"
          },
          on: {
            "click": function ($event) {
              return _vm.editGroupAction(scope.row, scope.$index);
            }
          }
        }, [_c('svg', {
          attrs: {
            "width": "22",
            "height": "20",
            "viewBox": "0 0 22 20",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            "d": "M15.7011 0.101062C17.1439 0.0119714 18.5666 0.506917 19.6387 1.47701C20.6206 2.5362 21.1216 3.94184 21.0414 5.37719V14.6228C21.1316 16.0581 20.6206 17.4638 19.6487 18.523C18.5767 19.493 17.1439 19.988 15.7011 19.8989H6.34292C4.8901 19.988 3.46734 19.493 2.39526 18.523C1.41335 17.4638 0.912379 16.0581 1.00255 14.6228V5.37719C0.912379 3.94184 1.41335 2.5362 2.39526 1.47701C3.46734 0.506917 4.8901 0.0119714 6.34292 0.101062H15.7011ZM10 14.801L16.7431 8.11919C17.3543 7.50546 17.3543 6.51556 16.7431 5.91173L15.4406 4.62487C14.8194 4.01114 13.8174 4.01114 13.1962 4.62487L12.5249 5.298C12.4247 5.39698 12.4247 5.56527 12.5249 5.66426C12.5249 5.66426 14.118 7.22829 14.1481 7.26788C14.2583 7.38667 14.3284 7.54505 14.3284 7.72323C14.3284 8.07959 14.0378 8.37656 13.6671 8.37656C13.4968 8.37656 13.3365 8.30727 13.2263 8.19838L11.553 6.55516C11.4729 6.47597 11.3326 6.47597 11.2524 6.55516L6.47317 11.2769C6.14253 11.6036 5.95216 12.0392 5.94214 12.5044L5.88202 14.8505C5.88202 14.9791 5.9221 15.0979 6.01227 15.187C6.10245 15.2761 6.22268 15.3256 6.35294 15.3256H8.70751C9.18844 15.3256 9.64933 15.1375 10 14.801Z",
            "fill": "#D4D8E2"
          }
        })])]), _c('button', {
          staticClass: "__group__action_btn delete-group",
          attrs: {
            "title": "this.$t('dashboard.groups.delete')"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteGroupAction(scope.row, scope.$index);
            }
          }
        }, [_c('svg', {
          attrs: {
            "width": "19",
            "height": "21",
            "viewBox": "0 0 19 21",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            "d": "M17.3902 3.80299C17.7804 3.80299 18.1052 4.12305 18.1052 4.53031V4.90686C18.1052 5.30421 17.7804 5.63418 17.3902 5.63418H0.767732C0.37658 5.63418 0.0517578 5.30421 0.0517578 4.90686V4.53031C0.0517578 4.12305 0.37658 3.80299 0.767732 3.80299H3.6921C4.28615 3.80299 4.80313 3.38582 4.93677 2.79722L5.08991 2.12142C5.32792 1.20087 6.1112 0.589478 7.00763 0.589478H11.1494C12.036 0.589478 12.8281 1.20087 13.0573 2.07286L13.2212 2.79623C13.3538 3.38582 13.8708 3.80299 14.4659 3.80299H17.3902ZM15.9045 17.5679C16.2098 14.7567 16.7444 8.07796 16.7444 8.01057C16.7639 7.80645 16.6966 7.61322 16.563 7.45765C16.4196 7.31198 16.2381 7.22578 16.0382 7.22578H2.12642C1.92548 7.22578 1.7343 7.31198 1.60164 7.45765C1.46703 7.61322 1.4007 7.80645 1.41045 8.01057C1.41224 8.02295 1.43142 8.25821 1.46349 8.65152C1.60594 10.3987 2.0027 15.2651 2.25908 17.5679C2.44052 19.2643 3.56715 20.3305 5.19906 20.3692C6.45836 20.3979 7.75569 20.4078 9.08229 20.4078C10.3318 20.4078 11.6009 20.3979 12.8992 20.3692C14.5877 20.3404 15.7133 19.293 15.9045 17.5679Z",
            "fill": "#D4D8E2"
          }
        })])])])];
      }
    }], null, false, 2063149490)
  })], 1), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])])]) : _vm._e()]), _c('ImportContactFromExcel', {
    ref: "importExcel",
    attrs: {
      "edit": _vm.groupFormData
    },
    on: {
      "cancel": _vm.cancelModal,
      "RefreshComponentFromExcel": function ($event) {
        return _vm.$emit('refreshContactsUpdatedGroup');
      },
      "addContactSuccess": _vm.refreshGroupEmit
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };